import axios from 'axios'
import store from './store'
// import router from './router'
import { sha256 } from 'js-sha256'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    let nowDate = new Date()
    let signTime = nowDate.getTime()
    if (store.state.token != null) {
      config.headers.sign_time = signTime
      config.headers.auth_Code = store.state.authCode
      config.headers.sign = sha256.hmac(store.state.token, signTime.toString() + store.state.authCode)
      config.headers.route = store.state.newroute
      config.headers.factory_id = store.state.factoryId
    }
    // 在发送请求设置cancel token
    config.cancelToken = new axios.CancelToken(cancel => {
      store.state.axiosPromiseArr.push({cancel})
  })
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
        // 401 清除token信息并跳转到登录页面
          store.commit('loginOut')
          if(error.response.headers['jump_page']){
            var jumpPage = error.response.headers['jump_page'] 
            localStorage.jumpPage = jumpPage
          }
          if (window.location.pathname.includes('/tv')){
            window.location.href="/tv/login"
          }else{
            window.location.href="/login"
          }
      }
    }
    return Promise.reject(error.response)
  }
)

export default axios